import { render } from "./iframe.vue?vue&type=template&id=0b606948&scoped=true&ts=true"
import script from "./iframe.vue?vue&type=script&lang=ts"
export * from "./iframe.vue?vue&type=script&lang=ts"

import "./iframe.vue?vue&type=style&index=0&id=0b606948&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b606948"]])

export default __exports__